import { useOutletContext, useNavigate } from 'react-router-dom';
import ManageGroupContent from '../components/settings/ManageGroupContent';
import ManagePaymentSubscriptionContent from '../components/settings/ManagePaymentSubscriptionContent';
import ManageCanvasContent from '../components/settings/ManageCanvasContent';
import ManagePasswordContent from '../components/settings/ManagePasswordContent';
import DeleteData from '../components/settings/DeleteData';
import TermAndConditions from '../components/settings/TermAndConditions';
import PrivacyPolicy from '../components/settings/PrivacyPolicy';

const SettingsPage = () => {
  const [activeSection] = useOutletContext();
 

  const renderContent = () => {
    switch(activeSection) {
      case 'manage-canvas':
      case 'manage-group':
      case 'manage-payments-&-subscription-plan':
      case 'manage-password':
      case 'delete':
      case 'terms-&-conditions':
      case 'privacy-policy':
        return (
          <div className="p-2 md:p-4">
            <div className="ml-6 p-2 md:p-4">
              <h2 className="txt-page-heading text-lg md:text-xl mb-4 md:mb-6">
                {activeSection.split('-').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </h2>
              {/* Component rendering based on section */}
              {activeSection === 'manage-group' && <ManageGroupContent />}
              {activeSection === 'manage-payments-&-subscription-plan' && <ManagePaymentSubscriptionContent />}
              {activeSection === 'manage-canvas' && <ManageCanvasContent />}
              {activeSection === 'manage-password' && <ManagePasswordContent />}
              {activeSection ===  'delete' && <DeleteData/>}
              {activeSection ===  'terms-&-conditions' && <TermAndConditions/>}
              {activeSection ===  'privacy-policy' && <PrivacyPolicy/>}
              {/* ...other components... */}
            </div>
          </div>
        );

      default:
        return (
          <div className="p-2 md:p-4">
            <div className=" rounded-xl p-4 md:p-6">
              <div className="text-center text-2xl, text-bold text-btn-primary">Select a section from the sidebar</div>
            </div>
          </div>
        );
    }
  };

  return renderContent();
};

export default SettingsPage;